import Bills from '.';
import { IRoute } from '../../utils/navigation/routes';
import BillDetail from './billDetail';
import BillsDownload from './billsDownload';
import BillsDownloadFeedback from './billsDownload/billsDownloadFeedback';
import ClaimsSelection from './claims/claimsOpening/ClaimsSelection';
import ClaimSummary from './claims/claimsOpening/ClaimSummary';
import FeedbackClaimOpening from './claims/claimsOpening/FeedbackClaimOpening';
import InvoiceManagement from './claims/claimsOpening/InvoiceManagement';
import ClaimType from './claims/claimsOpening/ClaimType';
import ClaimDetail from './claims/claimsHistory/claimDetail';
import ClaimsList from './claims/claimsHistory/claimsList';
import ModalDebtPayment from './modalDebtPayment';
import GcoFlow from './modalDebtPayment/gcoFlow';
import FeedbackGco from './modalDebtPayment/gcoFlow/feedback-gco';
import ModalRehabilitationLines from './modalDebtPayment/modalRehabilitationLines';
import RehabilitationLinesFeedback from './modalDebtPayment/modalRehabilitationLines/RehabilitationLinesFeedback';
import CommunicationsList from './claims/claimsHistory/CommunicationsList';
import CommunicationsDetail from './claims/claimsHistory/CommunicationsDetail';

export const billsRoutes: IRoute[] = [
    { path: '/bills', element: <Bills /> },
    { path: '/bills/bill-detail', element: <BillDetail /> },
    { path: '/bills/gco-flow', element: <GcoFlow /> },
    { path: '/bills/gco-flow/feedback', element: <FeedbackGco /> },
    { path: '/modal-debt-payment', element: <ModalDebtPayment /> },
    { path: '/modal-debt-payment/modal-rehabilitation-lines', element: <ModalRehabilitationLines /> },
    { path: '/modal-rehabilitation-lines/rehabilitation-lines-feedback', element: <RehabilitationLinesFeedback /> },
    { path: '/bills-download', element: <BillsDownload /> },
    { path: '/bills-download/feedback', element: <BillsDownloadFeedback /> },
    { path: '/claims/claims-selection', element: <ClaimsSelection /> },
    { path: '/claims/claim-summary', element: <ClaimSummary /> },
    {
        path: '/claims/feedback-claim-opening',
        element: <FeedbackClaimOpening />,
    },
    { path: '/claims/claim-type', element: <ClaimType /> },
    { path: '/claims/management-invoice', element: <InvoiceManagement /> },
    { path: '/claims/claim-list', element: <ClaimsList /> },
    { path: '/claims/claim-detail', element: <ClaimDetail /> },
    { path: '/claims/communications-list', element: <CommunicationsList /> },
    { path: '/claims/communications-detail', element: <CommunicationsDetail /> },
];
